export const companyPublicFlg = {
  DRAFT: 1,
  PUBLISH: 2,
} as const
export type CompanyPublicFlg =
  (typeof companyPublicFlg)[keyof typeof companyPublicFlg]

export const companyRegisterFlg = {
  BEFORE_ACCOUNT_ISSUANCE: 0,
  BEFORE_ACCOUNT_REGISTRATION: 1,
  BEFORE_COMPANY_INFO_REGISTRATION: 2,
  BEFORE_JOB_REGISTRATION: 3,
  REGISTERED: 4,
} as const
export type CompanyRegisterFlg =
  (typeof companyRegisterFlg)[keyof typeof companyRegisterFlg]

export interface GetWebSummaryResult extends BaseApiResult {
  title: string
  text: string
  imageUrl: string
}

export interface CompanyInfo {
  companyCode: string
  companyName: string
  companyLogoImagePath: string
  industry: string
  capital: string
  sales: string
  foundationDate: string
  investor: string
  employees: string
  averageAge: string
  companyUrl: string
  twitterUserName: string
  facebookUserName: string
  businessContents: string
  companyFeature: string
  postalCode: string
  prefecture: number
  addressCity: string
  addressLocal: string
  mapEmbed: string
  publicFlg: CompanyPublicFlg
}

export interface CompanyListInfo {
  companyCode: string
  companyName: string
  companyLogoImagePath: string
  rank: string
  rate: string
  repayment: string
  employments: { employmentId: number; employmentName: string }[]
  publicFlg: CompanyPublicFlg
  registerFlg: CompanyRegisterFlg
  updatedAt: string
  adviserEmployeeName: string
}

export interface FeeRateRange {
  min: number
  max: number
  rate: number
}

export interface CompanyAdministratorInfo {
  companyCode: string
  companyName: string
  companyLogoImagePath: string
  employeeCode: string
  employeeName: string
  employeeEmail: string
  employeeStatus: EmployeeStatus
  roleCode: string
  roleName: string
}

export interface GetCompanyAdministratorsArgs {
  num: number
  page: number
}

export interface GetCompanyAdministratorsResult extends BaseApiResult {
  totalCount: number
  companyAdministrators: CompanyAdministratorInfo[]
}

export interface CompanyAdditionalInfo {
  companyCode: string
  rank: string
  rate: string
  repayment: string
  employments: Employment[]
  managementNote: string
  careerPlus2CompanyId: string
  adviserEmployeeCode: string
  adviserEmployeeName: string
  recruitmentInformation: string
  feeRates: FeeRateRange[]
  feeRateType: 'old' | 'new'
}

export interface CreateCompanyArgs {
  companyName: string
  careerPlus2CompanyId: string
}
export interface CreateCompanyResult extends BaseApiResult {
  companyCode: string
}

export interface GetCompaniesArgs {
  num: number
  page: number
  rate?: string
  repayment?: string
  rank?: string
  publicFlg?: CompanyPublicFlg
  registerFlg?: CompanyRegisterFlg
  keyword?: string
  adviserEmployeeCode?: string
}
export interface GetCompaniesResult extends BaseApiResult {
  totalCount: number
  companies: CompanyListInfo[]
}

export interface GetCompanyInfoResult extends BaseApiResult {
  companyInfo: CompanyInfo
}

export interface GetCompanyAdditionalInfoResult extends BaseApiResult {
  companyAdditionalInfo: CompanyAdditionalInfo
}

export interface UpdateCompanyPublicFlgArgs {
  companyCode: string
  publicFlg: CompanyPublicFlg
}
export interface CreateCompanyAdministratorAccountArgs {
  companyCode: string
  employeeName: string
  employeeEmail: string
}
export interface ResendCompanyAdministratorAccountInvitationArgs {
  companyCode: string
}
export interface DeleteCompanyAdministratorAccountArgs {
  companyCode: string
}
export interface ResetPasswordCompanyAdministratorAccountArgs {
  companyCode: string
}
export interface UpdateCompanyArchiveFlgArgs {
  companyCode: string
  archiveFlg: boolean
}
export interface GetArchivedCompaniesArgs {
  num: number
  page: number
}
export interface GetArchivedCompaniesResult extends BaseApiResult {
  totalCount: number
  companies: CompanyListInfo[]
}
export interface SendCompanyInquiryFlgArgs {
  companyCode: string
  title: string
  text: string
}

export const companyType = {
  COMPANY: 0,
  ADMIN: 1,
} as const
export type CompanyType = (typeof companyType)[keyof typeof companyType]

export const ranks = ['未設定', 'S', 'A', 'B', 'C', 'D']
export const rates = [
  '未設定',
  '30%',
  '31%',
  '32%',
  '33%',
  '34%',
  '35%',
  '40%',
  '50%',
  '55%',
  '60%',
]
export const repayments = ['未設定', '規定ママ', '改変あり']

export const feeRateTypeItems = [
  {
    value: 'old',
    label: '旧料率',
  },
  {
    value: 'new',
    label: '新料率',
  },
]

export const companyEnabledServiceType = {
  AGENT: 1,
  SCOUT: 2,
}
